function createProject({
  slug,
  order,
  titleKey,
  descriptionKey,
  shortDescriptionKey,
  assetFolder,
  assetLogo,
  assetImages,
  embedUrl = "",
  techs = [],
  link = "",
}) {
  return {
    slug,
    order,
    titleKey,
    descriptionKey,
    shortDescriptionKey,
    assetFolder,
    assetLogo,
    assetImages,
    embedUrl,
    techs,
    link,
  };
}

export const projects = [
  createProject({
    slug: "tradeflow",
    order: 1,
    titleKey: "projects.items.tradeflow.title",
    descriptionKey: "projects.items.tradeflow.description",
    shortDescriptionKey: "projects.items.tradeflow.shortDescription",
    assetFolder: "/assets/projects/tradeflow/",
    assetLogo: "logo.png",
    assetImages: ["logo.png", "tradeflow_1.png", "tradeflow_2.png", "tradeflow_3.png"],
    embedUrl: "",
    techs: ["java", "spring-boot", "postgresql", "terraform", "next.js", "IA"],
  }),

  createProject({
    slug: "testeDasDeusas",
    order: 4,
    titleKey: "projects.items.testeDasDeusas.title",
    descriptionKey: "projects.items.testeDasDeusas.description",
    shortDescriptionKey: "projects.items.testeDasDeusas.shortDescription",
    assetFolder: "/assets/projects/teste-das-deusas/",
    assetLogo: "logo.png",
    assetImages: ["logo.png", "testedeusas_1.png", "testedeusas_2.png", "testedeusas_3.png"],
    embedUrl: "https://nevenkagarcia.com/home-teste-das-deusas/",
    techs: ["web", "react", "nodejs"],
  }),

  createProject({
    slug: "baby-bingo",
    order: 5,
    titleKey: "projects.items.babyBingo.title",
    descriptionKey: "projects.items.babyBingo.description",
    shortDescriptionKey: "projects.items.babyBingo.shortDescription",
    assetFolder: "/assets/projects/baby-bingo/",
    assetLogo: "logo.png",
    assetImages: [
      "logo.png",
      "babybingo_1.png",
      "babybingo_2.png",
      "babybingo_3.png",
      "babybingo_4.png",
    ],
    embedUrl: "https://babybingo.basilis.co/",
    techs: ["web", "javascript", "react", "nodejs"],
  }),

  createProject({
    slug: "screamm",
    order: 6,
    titleKey: "projects.items.screamm.title",
    descriptionKey: "projects.items.screamm.description",
    shortDescriptionKey: "projects.items.screamm.shortDescription",
    assetFolder: "/assets/projects/screamm/",
    assetLogo: "logo.png",
    assetImages: ["logo.png", "screamm_1.png", "screamm_3.png", "screamm_4.gif"],
    embedUrl: "",
    techs: ["game", "unity", "csharp", "photon"],
  }),

  createProject({
    slug: "colheita-octavio",
    order: 7,
    titleKey: "projects.items.colheitaOctavio.title",
    descriptionKey: "projects.items.colheitaOctavio.description",
    shortDescriptionKey: "projects.items.colheitaOctavio.shortDescription",
    assetFolder: "/assets/projects/colheita-octavio/",
    assetLogo: "logo.png",
    assetImages: [
      "logo.png",
      "colheita-octavio_1.png",
      "colheita-octavio_2.png",
      "colheita-octavio_3.gif",
      "colheita-octavio_4.gif",
    ],
    embedUrl: "",
    techs: ["game", "unity", "csharp", "mobile"],
  }),

  createProject({
    slug: "nr35vr",
    order: 8,
    titleKey: "projects.items.nr35vr.title",
    descriptionKey: "projects.items.nr35vr.description",
    shortDescriptionKey: "projects.items.nr35vr.shortDescription",
    assetFolder: "/assets/projects/nr35vr/",
    assetLogo: "logo.png",
    assetImages: [
      "logo.png",
      "nr-35-vr_1.png",
      "nr-35-vr_2.png",
      "nr-35-vr_3.png",
      "nr-35-vr_4.png",
    ],
    embedUrl: "",
    techs: ["game", "unity", "csharp", "vr"],
  }),

  createProject({
    slug: "youshallbreakblocks",
    order: 9,
    titleKey: "projects.items.youshallbreakblocks.title",
    descriptionKey: "projects.items.youshallbreakblocks.description",
    shortDescriptionKey: "projects.items.youshallbreakblocks.shortDescription",
    assetFolder: "/assets/projects/youshallbreakblocks/",
    assetLogo: "logo.png",
    assetImages: [
      "logo.png",
      "you-shall-break-blocks_1.png",
      "you-shall-break-blocks_2.png",
      "you-shall-break-blocks_3.png",
      "you-shall-break-blocks_4.gif",
    ],
    embedUrl: "",
    techs: ["game", "unity", "csharp", "mobile"],
  }),

  createProject({
    slug: "redesul-consorcios",
    order: 2,
    titleKey: "projects.items.redesulConsorcios.title",
    descriptionKey: "projects.items.redesulConsorcios.description",
    shortDescriptionKey: "projects.items.redesulConsorcios.shortDescription",
    assetFolder: "/assets/projects/redesul/",
    assetLogo: "logo.png",
    assetImages: ["logo.png", "redesul_1.png", "redesul_2.png", "redesul_3.png"],
    embedUrl: "",
    techs: ["IA", "bubble", "javascript", "n8n"],
  }),

  createProject({
    slug: "basilisco-montessori",
    order: 3,
    titleKey: "projects.items.basiliscoMontessori.title",
    descriptionKey: "projects.items.basiliscoMontessori.description",
    shortDescriptionKey: "projects.items.basiliscoMontessori.shortDescription",
    assetFolder: "/assets/projects/basilisco-montessori/",
    assetLogo: "logo.png",
    assetImages: ["logo.png"],
    embedUrl: "",
    techs: ["web", "react", "javascript", "mobile"],
    link: "/montessori",
  }),
];
